import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-body" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "tenant-name" }, "会社名", -1)
const _hoisted_4 = ["textContent"]
const _hoisted_5 = { class: "form-group form-check mt-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "is-available"
}, "利用可能", -1)
const _hoisted_7 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_8 = ["textContent"]
const _hoisted_9 = { class: "modal-footer" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal_base = _resolveComponent("modal-base")!

  return (_openBlock(), _createBlock(_component_modal_base, { onDismiss: _ctx.dismiss }, {
    title: _withCtx(() => [
      _createTextVNode(" 会社登録 ")
    ]),
    "modal-content": _withCtx(() => [
      _createElementVNode("form", {
        onKeyup: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.validate && _ctx.validate(...args)))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.companyName }]),
              id: "tenant-name",
              placeholder: "会社名",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.values.companyName) = $event))
            }, null, 2), [
              [_vModelText, _ctx.values.companyName]
            ]),
            _createElementVNode("div", {
              class: "invalid-feedback",
              textContent: _toDisplayString(_ctx.errors.companyName)
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              class: "form-check-input",
              id: "is-available",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.values.isAvailable) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.values.isAvailable]
            ]),
            _hoisted_6
          ]),
          (_ctx.requestError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("span", {
                  textContent: _toDisplayString(_ctx.requestError)
                }, null, 8, _hoisted_8)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.dismiss && _ctx.dismiss(...args)))
          }, "キャンセル"),
          (_ctx.isAdd)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onClickedRegister && _ctx.onClickedRegister(...args))),
                disabled: !_ctx.meta.valid
              }, "登録", 8, _hoisted_10))
            : _createCommentVNode("", true),
          (!_ctx.isAdd)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "btn btn-warning",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onClickedModify && _ctx.onClickedModify(...args))),
                disabled: !_ctx.meta.valid
              }, "修正", 8, _hoisted_11))
            : _createCommentVNode("", true)
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["onDismiss"]))
}